import React from 'react';
import { extractProps } from '@famly/mf_ts-utils_extract-props';
export function useTooltipRequiredProps(props) {
    return React.useMemo(() => extractProps(props, ['onMouseOver', 'onMouseLeave', 'onFocus', 'onBlur', 'onTouchStart']), [props]);
}
